import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Camera, Palette, Sparkles, Wand2 } from "lucide-react";
import { LOGO_URL } from "../../constants";

export const MagicHeader = () => (
  <div className="relative z-10 bg-gradient-to-r from-[#1E1B4B] via-[#312e81] to-[#1E1B4B] text-white overflow-hidden">
    <div className="absolute top-6 left-[10%] w-16 h-16 bg-[#E83E8C]/20 rounded-full blur-xl animate-float" />
    <div className="absolute bottom-4 right-[15%] w-20 h-20 bg-[#FF9F1C]/15 rounded-full blur-xl animate-float" style={{ animationDelay: '1s' }} />
    <div className="absolute top-1/2 left-[5%] w-10 h-10 bg-[#FFD166]/20 rounded-full blur-lg animate-float" style={{ animationDelay: '0.5s' }} />
    <div className="absolute bottom-8 left-[40%] w-8 h-8 bg-purple-400/15 rounded-full blur-lg animate-float" style={{ animationDelay: '1.5s' }} />

    <div className="max-w-5xl mx-auto px-4 py-4 relative">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white mb-4 transition-colors" data-testid="magic-back-btn">
        <ArrowLeft size={16} /> Back to Home
      </Link>
      <div className="text-center pb-8">
        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/10 backdrop-blur-sm mb-4 border border-white/10">
          <Wand2 size={14} className="text-[#FFD166]" />
          <span className="text-xs font-semibold tracking-wider uppercase bg-gradient-to-r from-[#FFD166] to-[#E83E8C] bg-clip-text text-transparent">AI-Powered Preview</span>
        </div>
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-bold mb-3">
          <span className="bg-gradient-to-r from-white via-[#FFD166] to-[#E83E8C] bg-clip-text text-transparent">DoozyGo Magic</span>
        </h1>
        <p className="text-white/60 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">
          See your room transformed into a stunning party venue — <span className="text-[#FFD166] font-medium">before you book</span>
        </p>

        <div className="flex items-center justify-center gap-3 mt-6">
          {[
            { icon: Camera, label: "Upload Photo" },
            { icon: Palette, label: "Pick Style" },
            { icon: Sparkles, label: "See Magic" },
          ].map((step, i) => (
            <div key={step.label} className="flex items-center gap-1.5">
              <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center">
                <step.icon size={13} className="text-[#FFD166]" />
              </div>
              <span className="text-[11px] text-white/50 hidden sm:inline">{step.label}</span>
              {i < 2 && <div className="w-8 h-px bg-white/15 mx-1 hidden sm:block" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const MagicLogoWatermark = () => (
  <div className="fixed inset-0 pointer-events-none z-0" style={{ opacity: 0.03, transform: 'rotate(-15deg)', transformOrigin: 'center center' }}>
    <div className="flex flex-col gap-8" style={{ marginTop: '-80px', marginLeft: '-80px', width: 'calc(100% + 160px)', height: 'calc(100% + 160px)' }}>
      {[...Array(12)].map((_, row) => (
        <div key={`mw-r-${row}`} className="flex gap-12 items-center" style={{ marginLeft: row % 2 === 0 ? '0px' : '80px' }}>
          {[...Array(14)].map((_, col) => (
            <img key={`mw-c-${col}`} src={LOGO_URL} alt="" className="h-14 w-auto flex-shrink-0 select-none" draggable={false} />
          ))}
        </div>
      ))}
    </div>
  </div>
);
